import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD0SkRIe5c4Zfz1CXk6xSMLvcbG955DRe4",
  authDomain: "sarrathi-constructions-invoice.firebaseapp.com",
  projectId: "sarrathi-constructions-invoice",
  storageBucket: "sarrathi-constructions-invoice.firebasestorage.app",
  messagingSenderId: "1021769276165",
  appId: "1:1021769276165:web:f7bf00aced9d920691b56c",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);